/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetReservationNotificationsV2200ResponseNotificationsInner
 */
export interface GetReservationNotificationsV2200ResponseNotificationsInner {
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotificationsV2200ResponseNotificationsInner
     */
    locationId: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotificationsV2200ResponseNotificationsInner
     */
    notificationType: string;
    /**
     * 
     * @type {string}
     * @memberof GetReservationNotificationsV2200ResponseNotificationsInner
     */
    customizableEmailText: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotificationsV2200ResponseNotificationsInner
     */
    notifyBySms: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetReservationNotificationsV2200ResponseNotificationsInner
     */
    notifyByWhatsapp: boolean;
}

/**
 * Check if a given object implements the GetReservationNotificationsV2200ResponseNotificationsInner interface.
 */
export function instanceOfGetReservationNotificationsV2200ResponseNotificationsInner(value: object): value is GetReservationNotificationsV2200ResponseNotificationsInner {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('notificationType' in value) || value['notificationType'] === undefined) return false;
    if (!('customizableEmailText' in value) || value['customizableEmailText'] === undefined) return false;
    if (!('notifyBySms' in value) || value['notifyBySms'] === undefined) return false;
    if (!('notifyByWhatsapp' in value) || value['notifyByWhatsapp'] === undefined) return false;
    return true;
}

export function GetReservationNotificationsV2200ResponseNotificationsInnerFromJSON(json: any): GetReservationNotificationsV2200ResponseNotificationsInner {
    return GetReservationNotificationsV2200ResponseNotificationsInnerFromJSONTyped(json, false);
}

export function GetReservationNotificationsV2200ResponseNotificationsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetReservationNotificationsV2200ResponseNotificationsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['locationId'],
        'notificationType': json['notificationType'],
        'customizableEmailText': json['customizableEmailText'],
        'notifyBySms': json['notifyBySms'],
        'notifyByWhatsapp': json['notifyByWhatsapp'],
    };
}

export function GetReservationNotificationsV2200ResponseNotificationsInnerToJSON(json: any): GetReservationNotificationsV2200ResponseNotificationsInner {
    return GetReservationNotificationsV2200ResponseNotificationsInnerToJSONTyped(json, false);
}

export function GetReservationNotificationsV2200ResponseNotificationsInnerToJSONTyped(value?: GetReservationNotificationsV2200ResponseNotificationsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': value['locationId'],
        'notificationType': value['notificationType'],
        'customizableEmailText': value['customizableEmailText'],
        'notifyBySms': value['notifyBySms'],
        'notifyByWhatsapp': value['notifyByWhatsapp'],
    };
}

